import React from 'react'
import { mockArticoloCardItem } from 'utils/mock'
import { HubBg } from '@components/atoms/Icons'
import { WContainer, WImage } from '@components/atoms'
import { HubCard } from '@components/molecules'
import { ArticoliCorrelati, Page, RoundHead } from '@components/organisms'
import styles from './HubTemplate.module.sass'
import { ArticoloType, PaginaType } from 'utils/types'

interface Props {
  pagina: PaginaType
  mainImageWidth?: number
  mainImageHeight?: number
  articoliCorrelati?: [ArticoloType]
  hideBg?: boolean
}

const HubTemplate = (props: Props) => {
  const {
    pagina,
    mainImageWidth = 60,
    mainImageHeight = 60,
    articoliCorrelati = [],
    hideBg = false,
  } = props

  const icon = pagina.mainImage ? (
    <WImage
      src={pagina.mainImage}
      maxHeight={mainImageHeight}
      maxWidth={mainImageWidth}
      priority
      loading="eager"
      alt={pagina.titolo}
      title={pagina.titolo}
      layout="intrinsic"
    />
  ) : null

  return (
    <Page pagina={pagina} item={pagina}>
      <div className={styles.hubTemplate}>
        <RoundHead
          breadcrumbs={pagina.breadcrumbs}
          title={pagina.titolo}
          icon={icon}
          description={pagina.descrizione}
          color="white"
          className={styles.head}
        />
        <div className={styles.main}>
          {!hideBg && (
            <div className={styles.bg}>
              <HubBg />
            </div>
          )}
          <WContainer>
            <div className={styles.list}>
              {pagina.elementi.map((x, index) => (
                <div className={styles.item} key={x.titolo}>
                  <HubCard item={x} reverse={index % 2 === 1} />
                </div>
              ))}
            </div>
          </WContainer>
        </div>
        {articoliCorrelati.length > 0 && (
          <div className={styles.bottom}>
            <WContainer>
              <ArticoliCorrelati
                item={{
                  pk: 1,
                  name: 'Gli articoli più letti',
                  children: articoliCorrelati,
                }}
              />
            </WContainer>
          </div>
        )}
      </div>
    </Page>
  )
}

export default HubTemplate
